import moment from "moment";

import styles from "./RainBarChart.module.css";

export interface RainDataPoint {
  time: number;
  value: number;
}
export type RainBarChartData = RainDataPoint[];

export interface Props {
  rainBarChartData: RainBarChartData;
  chartTop?: number;
  showsData: boolean;
}

export const renderDatTimeYAxis = (epoxNumber: number) => {
  const momentDateTime = moment(new Date(epoxNumber));
  const timePart = momentDateTime.format("hh:mm");
  const datePartPart = momentDateTime.format("DD/MM/'YY");
  return (
    <div>
      {timePart}
      <br />
      {datePartPart}
    </div>
  );
};

const RainBarChart: React.FC<Props> = ({ rainBarChartData, chartTop, showsData }) => {
  const maxRainPerTimeStep = chartTop
    ? chartTop
    : Math.max(...rainBarChartData.map((rainDataPoint) => rainDataPoint.value));
  const fistDateTime = rainBarChartData[0]?.time;
  const lastDateTime = rainBarChartData[rainBarChartData.length - 1]?.time;

  return (
    <div className={`${styles.RainBarChart} ${!showsData ? styles.RainBarChartNoData : ""}`}>
      <div className={styles.RainBarChartYAxis}>
        <div>{maxRainPerTimeStep}mm</div>
        <div>0</div>
      </div>
      <div className={styles.RainBarChartBars}>
        {rainBarChartData.map(({ time, value }) => {
          const relativeValue = Math.round(Math.min((value / maxRainPerTimeStep) * 100, 100));
          return (
            <div
              key={time + ""}
              style={{
                height: relativeValue + "%",
              }}
            />
          );
        })}
      </div>
      <div className={styles.RainBarChartXAxis}>
        {fistDateTime ? renderDatTimeYAxis(fistDateTime) : null}
        {lastDateTime ? renderDatTimeYAxis(lastDateTime) : null}
      </div>
    </div>
  );
};

export default RainBarChart;
